/** Small drop that falls and lands with a squish. Remount (change `key`) to replay it. */
export function KlacksDrop() {
  return (
    <span className="flex h-4 w-3 shrink-0 items-end justify-center" aria-hidden>
      <span className="klacks-drop size-2 rounded-full bg-primary" />
    </span>
  );
}
